import { ShieldCheck, ShieldAlert, Star, Globe, Clock, AlertTriangle } from "lucide-react";

export const placePhotoUrl = (name, maxwidth = 640) =>
  name ? `${process.env.REACT_APP_BACKEND_URL}/api/places/photo?name=${encodeURIComponent(name)}&maxwidth=${maxwidth}` : null;

const chip = "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs";

export const PlaceBadges = ({ item, dark = false }) => {
  if (!item) return null;
  const g = item.google;
  const v = item.verified;
  const muted = dark ? "text-[#FDFBF7]/70" : "text-muted-foreground";
  return (
    <div className="flex flex-wrap items-center gap-1.5 mt-3" data-testid="place-badges">
      {v === true && (
        <span data-testid="badge-verified" title="Verified against Google Places" className={`${chip} bg-[#1A3B2B]/10 text-[#1A3B2B]`}>
          <ShieldCheck className="w-3 h-3" /> Verified
        </span>
      )}
      {v === false && (
        <span data-testid="badge-unverified" title="We couldn't confirm this place, so details may be inaccurate" className={`${chip} bg-[#C8553D]/12 text-[#C8553D]`}>
          <ShieldAlert className="w-3 h-3" /> Unverified — details not confirmed
        </span>
      )}
      {item.closed_permanently && (
        <span className={`${chip} bg-red-100 text-red-700`}>
          <AlertTriangle className="w-3 h-3" /> Permanently closed
        </span>
      )}
      {item.substituted && (
        <span className={`${chip} bg-[#B8860B]/15 text-[#8a6608]`} title={item.original_name ? `Originally suggested: ${item.original_name}` : ""}>
          Adjusted to a verified nearby place
        </span>
      )}
      {g?.rating != null && (
        <span className={`${chip} ${dark ? "bg-white/10 text-[#FDFBF7]" : "bg-[#F3EFE8] text-[#1A3B2B]"}`}>
          <Star className="w-3 h-3 fill-[#C8553D] text-[#C8553D]" /> {g.rating}{g.user_rating_count ? ` (${g.user_rating_count})` : ""}
        </span>
      )}
      {g?.price_level && <span className={`${chip} ${dark ? "bg-white/10 text-[#FDFBF7]" : "bg-[#F3EFE8] text-[#1A3B2B]"}`}>{g.price_level}</span>}
      {g?.open_now === true && <span className={`${chip} bg-green-100 text-green-700`}><Clock className="w-3 h-3" /> Open now</span>}
      {g?.open_now === false && <span className={`${chip} ${dark ? "bg-white/10" : "bg-black/5"} ${muted}`}><Clock className="w-3 h-3" /> Closed now</span>}
      {g?.website && (
        <a href={g.website} target="_blank" rel="noopener noreferrer" className={`${chip} ${dark ? "bg-white/10 text-[#FDFBF7]" : "bg-black/5 text-[#1A3B2B]"} hover:underline`}>
          <Globe className="w-3 h-3" /> Website
        </a>
      )}
    </div>
  );
};
